import React, { useState } from "react";
import { format } from "date-fns";
import addMonths from "date-fns/addMonths";
import subMonths from "date-fns/subMonths";
import startOfISOWeek from "date-fns/startOfISOWeek";
import addDays from "date-fns/addDays";
import startOfMonth from "date-fns/startOfMonth";
import endOfMonth from "date-fns/endOfMonth";
import endOfISOWeek from "date-fns/endOfISOWeek";
import isSameMonth from "date-fns/isSameMonth";
import { NextIcon, PrevIcon } from "../../assets/Icons";
import moment from "moment";

const CustomCalender = ({ selectedDate, setSelectedDate }) => {
  const [currentMonth, setCurrentMonth] = useState(new Date());

  const renderHeader = () => {
    const dateFormat = "MMMM yyyy";

    return (
      <div className="header row flex-middle ">
        <div className="col-2 col-start" onClick={prevMonth}>
          <span>
            <PrevIcon />
          </span>
        </div>
        <div className="col-8 col-center">
          <span className="monthheading">{format(currentMonth, dateFormat)}</span>
        </div>
        <div className="col-2 col-end" onClick={nextMonth}>
          <span>
            <NextIcon />
          </span>
        </div>
      </div>
    );
  };

  const renderDays = () => {
    const dateFormat = "eee";
    const days = [];
    let startDate = startOfISOWeek(currentMonth);

    for (let i = 0; i < 7; i++) {
      days.push(
        <div className="col col-center" key={i}>
          <strong className="text-dark">{format(addDays(startDate, i), dateFormat)}</strong>
        </div>
      );
    }
    return <div className="days row">{days}</div>;
  };

  const renderCells = () => {
    const monthStart = startOfMonth(currentMonth);
    const monthEnd = endOfMonth(monthStart);
    const startDate = startOfISOWeek(monthStart);
    const endDate = endOfISOWeek(monthEnd);
    const dateFormat = "d";
    const rows = [];
    let days = [];
    let day = startDate;
    let formattedDate = "";

    while (day <= endDate) {
      for (let i = 0; i < 7; i++) {
        formattedDate = format(day, dateFormat);
        const cloneDay = new Date(day);
        cloneDay.setHours(23, 59, 59, 999);
        const isActive = moment(selectedDate).format("DD-MM-YYYY") === moment(cloneDay).format("DD-MM-YYYY");
        const isDateDisabled = new Date(day).getTime() >= Date.now();
        days.push(
          <div
            className={`col cell ${!isSameMonth(day, monthStart) ? "disabled" : isActive ? "selected" : ""} ${
              isDateDisabled ? "disabled-day" : ""
            }`}
            key={format(day, "yyyyMMdd") + i}
            onClick={!isDateDisabled ? () => onDateClick(cloneDay) : () => {}}
          >
            <span className="number">{formattedDate}</span>
          </div>
        );
        day = addDays(day, 1);
      }
      rows.push(
        <div className="row" key={day}>
          {days}
        </div>
      );
      days = [];
    }
    return <div className="body">{rows}</div>;
  };

  const onDateClick = (day) => {
    setSelectedDate(day);
  };

  const nextMonth = () => {
    setCurrentMonth(addMonths(currentMonth, 1));
  };

  const prevMonth = () => {
    setCurrentMonth(subMonths(currentMonth, 1));
  };

  return (
    <div className="calendar">
      <div className="custom-calendar">
        {renderHeader()}
        {renderDays()}
        {renderCells()}
      </div>
    </div>
  );
};

export default CustomCalender;
